<template>
  <v-dialog :model-value="dialog" fullscreen persistent no-click-animation transition="dialog-top-transition" @keydown.esc="closeModal">
    <v-card class="error-modal d-flex align-center justify-center">
      <div class="text-center">
        <v-icon size="120" color="white" class="mb-6 pulse-animation">
          mdi-alert-circle
        </v-icon>

        <h1 class="error-title mb-4">ERROR</h1>

        <p class="error-message mb-8">
          {{ message }}
        </p>

        <v-btn size="x-large" color="white" variant="outlined" @click="closeModal" class="px-8"
          @keydown.enter="closeModal" autofocus>
          <v-icon start>mdi-close</v-icon>
          CERRAR
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalError",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Ha ocurrido un error inesperado",
    },
  },
  emits: ["close"],
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.playErrorSound();
        window.addEventListener("keydown", this.handleKeydown);
      } else {
        window.removeEventListener("keydown", this.handleKeydown);
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleKeydown(event) {
      if (event.key === "Enter") {
        this.closeModal();
      }
    },
    playErrorSound() {
      if ("speechSynthesis" in window) {
        const utterance = new SpeechSynthesisUtterance("ERROR");
        utterance.lang = "es-ES";
        utterance.volume = 3;
        utterance.rate = 0.8;
        utterance.pitch = 0.8;
        window.speechSynthesis.speak(utterance);
      }
    },
  },

};
</script>

<style scoped>
.error-modal {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 50%, #991b1b 100%);
  color: white;
  height: 100vh;
}

.error-title {
  font-size: 4rem;
  font-weight: 900;
  letter-spacing: 0.2em;
  text-shadow: 3px 3px 6px rgba(255, 255, 255, 0.5);
  color: #ffffff;
  animation: shake 0.5s ease-in-out;
}

.error-message {
  font-size: 1.5rem;
  font-weight: 500;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
  color: #ffffff;
}

.pulse-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}

.v-btn {
  font-weight: 700;
  letter-spacing: 0.1em;
  border-width: 2px !important;
  transition: all 0.3s ease;
}

.v-btn:hover {
  background-color: white !important;
  color: #dc2626 !important;
  transform: scale(1.05);
}
</style>
